import GhTable from "@/components/ghTable/ghTable";

import GhTree from "@/components/ghTree/ghTree";

import GhDialog from "@/components/ghDialog/ghDialog";

import GhProgress from "@/components/ghProgress/ghProgress";

import GhConfirmDialog from "@/components/ghConfirmDialog/ghConfirmDialog";

import GhPage from "@/components/ghPage/ghPage";

import GhDataView from "@/components/ghDataView/ghDataView";

import GhInvoke from "../components/ghInvoke/ghInvoke";

import GhTablePage from "../components/ghTablePage/ghTablePage";

import GhDatePicker from "../components/ghDatePicker/ghDatePicker";

import GhModelView from "../components/ghModelView/ghModelView";

import GhTabsPage from "../components/ghTabsPage/ghTabsPage";

import GhBusinessTree from "../components/ghBusinessTree/ghBusinessTree";

import GhUpload from "../components/ghUpload/ghUpload";

import GhImage from "../components/ghImage/ghImage";

import GhPdf from "../components/ghPdf/ghPdf";

import DataTable from "@/components/ghTable/dataTable/dataTable";

import PropView from "@/components/ghModelView/propView/propView";

import GhCustomFilter from "@/components/ghCustomFilter/ghCustomFilter";

import GhInput from "@/components/ghInput/ghInput";

import GhCodeEditor from "@/components/ghCodeEditor/ghCodeEditor";

import GhDynamicInvoke from "@/components/ghDynamicInvoke/ghDynamicInvoke";

import GhVideo from "@/components/ghVideo/ghVideo";

import GhMenu from "@/components/ghMenu/ghMenu";

import GhDiagram from "@/components/ghDiagram/ghDiagram";

import GhRange from "@/components/ghRange/ghRange.vue";

import MaterialSelector from "../businessComponents/mdl/materialSelector/materialSelector";

import GhImport from "@/components/ghImport/ghImport";

import GhChart from "@/components/ghChart/ghChart";

import codeComponent from "@/components/codeComponent.vue";

// import { Table, TableColumn, Input, InputNumber, Cascader } from "element-ui";

import Stomp from "stompjs";

const GhCom = {
  install(Vue) {
    Vue.component("gh-table", GhTable);

    Vue.component("gh-tree", GhTree);

    Vue.component("gh-progress", GhProgress);

    Vue.component("gh-dialog", GhDialog);

    Vue.component("gh-confirm-dialog", GhConfirmDialog);

    Vue.component("gh-page", GhPage);

    Vue.component("gh-data-view", GhDataView);

    Vue.component("gh-invoke", GhInvoke);

    Vue.component("gh-table-page", GhTablePage);

    Vue.component("gh-date-picker", GhDatePicker);

    Vue.component("gh-model-view", GhModelView);

    Vue.component("gh-tabs-page", GhTabsPage);

    Vue.component("gh-business-tree", GhBusinessTree);

    Vue.component("gh-upload", GhUpload);

    Vue.component("gh-img", GhImage);

    Vue.component("gh-pdf", GhPdf);

    Vue.component("gh-data-table", DataTable);

    Vue.component("gh-prop-view", PropView);

    Vue.component("gh-custom-filter", GhCustomFilter);

    Vue.component("gh-input", GhInput);

    Vue.component("gh-code-editor", GhCodeEditor);

    Vue.component("gh-dynamic-invoke", GhDynamicInvoke);

    Vue.component("gh-video", GhVideo);

    Vue.component("gh-menu", GhMenu);

    Vue.component("gh-diagram", GhDiagram);

    Vue.component("gh-range", GhRange);

    Vue.component("gh-material-selector", MaterialSelector);

    Vue.component("gh-import", GhImport);

    Vue.component("gh-chart", GhChart);

    Vue.component("Stomp", Stomp);

    Vue.component("gh-template-component", codeComponent);
  }
};

export default GhCom;
